import "./dropdown-multi-item.scss";
import { DropdownItemInterface } from "../../models/interfaces/dropdown-item.interface";

interface DropdownMultiItemProps extends DropdownItemInterface {
  handleChange: () => void;
  isChecked: boolean;
  disabled?: boolean;
}

export function DropdownMultiItem({ isChecked = false, id, title, disabled, handleChange }: DropdownMultiItemProps) {
  return (
    <div className="polymer-dropdown-item">
      <input
        type="checkbox"
        id={id.toString()}
        name={id.toString()}
        value={id}
        checked={isChecked}
        className="polymer-dropdown-item__checkbox"
        onChange={handleChange}
        disabled={disabled}
      />
      <label htmlFor={id.toString()} className="polymer-dropdown-item__label">
        {title}
      </label>
    </div>
  );
}
